import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { SignaturePadComponent } from '@almothafar/angular-signature-pad';

@Component({
  selector: 'app-signature-field',
  templateUrl: './signature-field.component.html',
  styleUrls: ['./signature-field.component.css']
})
export class SignatureFieldComponent {
  @Input() value = '';
  @Input() disabled = false;
  @Output() valueChange = new EventEmitter<string>();
  pad: SignaturePadComponent;
  @ViewChild('pad') set signaturePad(pad: SignaturePadComponent) {
    this.pad = pad;
    if (pad) requestAnimationFrame(() => { if (this.pad === pad) pad.redrawCanvas(); });
  }

  padOptions = { minWidth: 1, maxWidth: 2.5, penColor: 'rgb(20, 40, 90)', backgroundColor: 'rgb(255, 255, 255)', canvasWidth: 600, canvasHeight: 180 };

  get imageUrl(): string {
    return this.value ? (this.value.startsWith('data:image/') ? this.value : `data:image/png;base64,${this.value}`) : '';
  }

  onDrawEnd(): void {
    if (!this.disabled && this.pad && !this.pad.isEmpty()) {
      this.valueChange.emit(this.pad.toDataURL().split(',')[1]);
    }
  }

  clear(): void {
    if (this.disabled) return;
    this.pad?.clear();
    this.valueChange.emit('');
  }
}
